import { Validator } from '@vista-digital/validator';
/**
 * Mode options for the Member Transaction List component totals.
 */
export var TransactionTotalsMode;
(function (TransactionTotalsMode) {
    TransactionTotalsMode["BalanceAdjustment"] = "BalanceAdjustment";
    TransactionTotalsMode["Price"] = "Price";
})(TransactionTotalsMode || (TransactionTotalsMode = {}));
/**
 * Default configuration options for the Member Transaction List component.
 */
export const defaultMemberTransactionListConfig = {
    numberOfTransactionsToLoad: 10,
    transactionTotalsMode: TransactionTotalsMode.BalanceAdjustment
};
export const memberTransactionListConfigValidator = Validator.object({
    numberOfTransactionsToLoad: Validator.number({ min: 1 }),
    transactionTotalsMode: Validator.oneOf(Object.values(TransactionTotalsMode))
});
